import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  generateTeamsSiteRequest,
  generateTeamsSiteSuccess,
} from 'actions/teamsActions';
import axios from 'axios';
import config from 'constants/apiConfig';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { MicrosoftTemplate } from 'types/template';
import { keys } from './useFetchIncidentWorkspaceTeamStatus';

type GenerateIncidentWorkspaceTeamSiteInput = {
  template: MicrosoftTemplate;
  tenantId: UUID;
  incidentId?: UUID;
};

export const useGenerateIncidentWorkspaceTeamSite = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  return useMutation<any, any, GenerateIncidentWorkspaceTeamSiteInput>({
    mutationFn: async ({ template, tenantId, incidentId }) => {
      dispatch(generateTeamsSiteRequest(incidentId));
      const response = await axios(config.apiGateway.generateTeamSite, {
        method: 'POST',
        data: {
          incident_id: incidentId,
          template,
          tenantId,
        },
      });
      return response?.data;
    },
    onSuccess: ({ message, status }, { incidentId }) => {
      if (status === 'In progress') {
        toast.success(message);
      }
      dispatch(generateTeamsSiteSuccess());

      queryClient.invalidateQueries({
        queryKey: [keys.incidentWorkspaceTeamStatus, incidentId],
      });
    },
  });
};
